import classNames from 'classnames';
import React from 'react';
import styles from './SimpleUserCard.module.scss';
import { Text } from './typography';
import defaultLogo from '../assets/workspace_image.png';
import Icon from './Icon';
import { customColors } from '../utilities';
import { t } from 'i18next';
import { keys } from '../utilities/translator/translation_keys';

export default function SimpleWorkspaceCard({
  workspace,
  weight = 'semiBold',
  size = 'md',
  largeAvatar = false,
  mediumAvatar = false,
  className,
  hideAvatar = false,
  hideNameOnMobile = false,
  smallText = '',
}) {
  return workspace?.id && !hideAvatar ? (
    <div className={classNames(styles.workspaceContainer, className)}>
      {!hideAvatar && (
        <>
          {workspace?.title === 'Shared' || !workspace ? (
            <Icon
              style={{
                fontSize: size === 'sm' ? '1rem' : '1.2rem',
                color: customColors.BLUE,
                opacity: 0.8,
              }}
            >
              public
            </Icon>
          ) : (
            <img
              alt="user avatar"
              src={workspace?.logoUrl || defaultLogo}
              className={
                mediumAvatar
                  ? styles.mediumAvatar
                  : largeAvatar
                  ? styles.largeAvatar
                  : styles.avatar
              }
            />
          )}
        </>
      )}
      <div className={styles.column}>
        <Text
          className={classNames(
            styles.text,
            hideNameOnMobile && styles.hideTextOnMobile,
          )}
          size={size}
          noMargin
          weight={weight}
          noSelect
          truncate
        >
          {workspace?.title === 'Shared'
            ? t(keys.common.SHARED)
            : workspace?.title}
        </Text>
        <Text size="sm" noMargin color="secondary">
          {smallText}
        </Text>
      </div>
    </div>
  ) : workspace?.id ? (
    <div
      className={classNames(
        styles.container,
        hideNameOnMobile && styles.hideTextOnMobile,
        className,
      )}
    >
      <Text size={size} noMargin weight={weight} noSelect>
        {workspace?.title}
      </Text>
    </div>
  ) : (
    <div className={styles.sharedContainer}>
      <Icon
        style={{
          color: customColors.BLUE,
          fontSize: size === 'sm' ? '1rem' : '1.2rem',
        }}
      >
        public
      </Icon>
      <Text noMargin size={size} weight={weight}>
        {t(keys.common.SHARED)}
      </Text>
    </div>
  );
}
